import {
  REJECT_REASON_ALL_GET, REJECT_REASON_ALL_GET_SUCCESS, REJECT_REASON_ALL_GET_FAILURE
} from './mutation-types'

export default {
  state: {
    rejectreasonsAll: []
  },
  getters: {
    rejectreasonsAll: state => {
      return state.rejectreasonsAll
    }
  },
  actions: {
    [REJECT_REASON_ALL_GET] ({dispatch, state, commit}, params = null) {
      var data = {}
      dispatch('apiGet', {url: '/master/reject_reasons/all_get', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REJECT_REASON_ALL_GET_FAILURE, res.data)
          } else {
            commit(REJECT_REASON_ALL_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [REJECT_REASON_ALL_GET_FAILURE] (state, data) {
      console.log('REJECT_REASON_ALL_GET_FAILURE')
    },
    [REJECT_REASON_ALL_GET_SUCCESS] (state, data) {
      console.log('REJECT_REASON_ALL_GET_SUCCESS')
      state.rejectreasonsAll = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rejectreason.js